import React from 'react';
import { Input } from 'reactstrap';
import { Option } from '../../../../../../../../../entities/v1/survey_engine/Option';
import {
  Select,
  SelectOption,
} from '../../../../../../../../../components/Select';

interface AnswerInputProps {
  selectedQuestionType: string | null;
  questionTitle: string | null;
  answerValue: string | null;
  questionOptions: Option[];
  isLoading: boolean;
  onAnswerChange: (value: string) => void;
}

export function AnswerInput({
  selectedQuestionType,
  questionTitle,
  answerValue,
  questionOptions,
  isLoading,
  onAnswerChange,
}: AnswerInputProps) {
  // Disabled state if no question is selected
  if (!selectedQuestionType || !questionTitle) {
    return (
      <Select
        options={[{ value: '', label: 'Select a question first' }]}
        selected={null}
        disabled={true}
        placeholder='Select Question'
      />
    );
  }

  switch (selectedQuestionType) {
    case 'boolean':
      // Yes/No dropdown
      return (
        <Select
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          selected={
            answerValue
              ? {
                  value: answerValue,
                  label: answerValue === 'true' ? 'Yes' : 'No',
                }
              : null
          }
          onChange={(option) => onAnswerChange(option.value)}
          disabled={isLoading}
          placeholder='Select Answer'
        />
      );

    case 'options':
    case 'multi_options': {
      // Options dropdown - always single select for search
      const optionsForSelect: SelectOption[] = questionOptions.map(
        (option) => ({
          value: option.name || '',
          label: String(option.name || option.id),
        }),
      );

      return (
        <Select
          options={optionsForSelect}
          selected={
            answerValue ? { value: answerValue, label: answerValue } : null
          }
          onChange={(option) => onAnswerChange(option.value)}
          disabled={isLoading || questionOptions.length === 0}
          placeholder='Select Answer'
        />
      );
    }

    default:
      // Text input for all other types
      return (
        <Input
          type='text'
          value={answerValue || ''}
          onChange={(e) => onAnswerChange(e.target.value)}
          placeholder='Enter Text'
          disabled={isLoading}
          aria-label='Enter text answer'
        />
      );
  }
}
